import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { LanguageApiService } from '@ninety/mobile/platform/api';

import { appActions } from '../../app/app.actions';

import { LanguageActions } from './language.actions';

@Injectable()
export class LanguageEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly languageApi = inject(LanguageApiService);

  initGlobalState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(appActions.initGlobalState),
      switchMap(() =>
        this.languageApi.getCompanyLanguage().pipe(
          map(companyLanguage => LanguageActions.getCompanyLanguageSuccess({ companyLanguage })),
          catchError((error: unknown) => of(LanguageActions.getCompanyLanguageError({ error })))
        )
      )
    )
  );
}
